import * as React from 'react';
export const hostedCheckoutSvg = React.forwardRef(
  function hostedCheckoutSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M14.5 2.75c0-.69-.56-1.25-1.25-1.25H2.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25V2.75Zm1.5 10.5A2.75 2.75 0 0 1 13.25 16H2.75A2.75 2.75 0 0 1 0 13.25V2.75A2.75 2.75 0 0 1 2.75 0h10.5A2.75 2.75 0 0 1 16 2.75v10.5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M8.75 15h-1.5V1h1.5v14Z',
      }),
    );
  },
);
hostedCheckoutSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var hostedCheckout = {
  category: 'icon',
  colorable: true,
  name: 'hostedCheckout',
  svg: hostedCheckoutSvg,
};
